<!-- Lightweight, reusable confirm dialog (Bootstrap-friendly) -->
<div *ngIf="visible" class="fixed-top w-100 h-100" style="background: rgba(0,0,0,.5);" (click)="close(false)">
  <div class="position-absolute top-50 start-50 translate-middle" (click)="$event.stopPropagation()" style="min-width:320px; max-width:90vw;">
    <div class="card shadow">
      <div class="card-header fw-semibold">
        {{ title }}
      </div>
      <div class="card-body">
        <p class="mb-0">{{ message }}</p>
      </div>
      <div class="card-footer d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-outline-secondary" (click)="close(false)">
          {{ cancelText }}
        </button>
        <button type="button" class="btn btn-danger" (click)="close(true)">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</div>
